<template>
    <div class="card-container">
        <div class="header-container">
            <span class="header-title">{{ headerTitle }}</span>
            <img class="close-icon" v-on:click="this.cancel" :src="closeIcon" alt="close" />
        </div>
        <div class="card-content-container">
            <slot />
        </div>
        <BottomNavigation
            class="bottom-nav"
            :first="true"
            :cancel="showCancel ? this.cancel : undefined"
            :no="this.no"
            :yes="this.yes"
            :yesText="yesText"
            :noText="noText"
            :cancelText="cancelText"
            :smallMarginRight="true"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BottomNavigation from '../layout/BottomNavigation.vue';

export default defineComponent({
    components: { BottomNavigation },
    props: {
        headerTitle: { type: String, required: true },
        activeValidate: { type: Boolean, required: false },
        showCancel: { type: Boolean, required: false, default: false },
        yesText: { type: String, required: false },
        noText: { type: String, required: false },
        cancelText: { type: String, required: false },
    },
    emits: ['yes', 'no', 'cancel'],
    methods: {
        yes() {
            this.$emit('yes');
        },
        no() {
            this.$emit('no');
        },
        cancel() {
            this.$emit('cancel');
        },
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-white.svg');
        },
    },
});
</script>

<style scoped>
.card-container {
    min-width: 550px;
    max-width: 90vw;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.card-content-container {
    padding: 16px;
    background-color: var(--white);
    overflow: auto;
    max-height: 25vh;
}
.header-container {
    position: relative;
    padding: 12px 24px;
    background-color: var(--bleu-prinicipal);
}
.header-title {
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-large);
    color: var(--white);
}
.bottom-nav {
    position: relative;
    height: 55px;
    z-index: 999;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
</style>
